import React, { useEffect, useState } from 'react'
import { makeSideBarActive } from '../../utils/EllowUtils';
import SideMenu from '../sideMenu'
import DashboardHeader from '../topbar'
import * as CONSTANTS from "../../utils/CONSTANTS";
import Styles from "./styles.module.scss";
import Table from '../../components/table';
import { getCompany, getCompanyTimesheetList } from './services';
import totalCountIcon from '../../assets/images/crown_icon_fill.svg';

const CompanyTimesheet = () => {

  const BreadcrumsValues = ["Companywise Timesheets"];
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 4);
  const [filterNumber, setFilterNumber] = useState<number>()
  const [filterValues, setFilterValues] = useState<any>()
  const [timesheetData, setTimesheetData] = useState<any>()
  const [timesheetCount, setTimesheetCount] = useState<any>()
  const [sort, setSort] = useState<any>([]);
  const [companyList, setCompanyList] = useState<any>();

   useEffect(() => {
   
     getCompanyTimesheets(1, 25, '', '', '')
     getCompanyList()
   }, [])
   
   const getCompanyList = () => {
    getCompany().then((response: any) => {
      if (response && response.status === "1") {
        setCompanyList(response.data);
      }
    });
  };
  
  
  const getCompanyTimesheets = (pageNumber?: number, pageSize?: number, search?: string, filters?: any, sort?: any) => {

    let body = {}
    if (filters) {
      // filters.customerId = filters.customerId && filters.customerId.map((item: any) => item.companyId)
      // filters.approvalNeeded = filters.approvalNeeded && filters.approvalNeeded.id === 0 ? true : false
      // filters.leaves = filters.leaves && filters.leaves.id === 0 ? true : false
      // filters.leavesCarryForward = filters.leavesCarryForward && filters.leavesCarryForward.id === 0 ? true : false
      body = {
        filters: {
          customerId: filters && filters.customerId && filters.customerId.map((item: any) => item.companyId),
          approvalNeeded:  filters && filters.approvalNeeded ? filters.approvalNeeded.name && filters.approvalNeeded.name === 'Yes' ? true : filters.approvalNeeded.name === 'No' ? false : undefined : undefined,
          leaves:  filters && filters.leaves ? filters.leaves.name && filters.leaves.name === 'Yes' ? true : filters.leaves.name === 'No' ? false : undefined : undefined,
          leavesCarryForward:  filters && filters.leavesCarryForward ? filters.leavesCarryForward.name && filters.leavesCarryForward.name === 'Yes' ? true : filters.leavesCarryForward.name === 'No' ? false : undefined : undefined
        },
        "sort": {
          "sortBy": sort && sort.length > 0 ? sort[0] && sort[0].field : "approvalNeeded",
          "sortOrder": sort && sort.length > 0 ? sort[0] && sort[0].dir : "ASC"
        },
      }
    }
    else {
      body = {
        filters:{},
        "sort": {
          "sortBy": sort && sort.length > 0 ? sort[0] && sort[0].field : "approvalNeeded",
          "sortOrder": sort && sort.length > 0 ? sort[0] && sort[0].dir : "ASC"
        },
      }
    }


    getCompanyTimesheetList(pageNumber, pageSize, search, body ).then((response) => {
      if (response && response.status === 1) {
        setTimesheetData(response.data)
        setTimesheetCount(response.responseCount)
       }
     })
  }

    const applyFilter = (data: any) => {
    
      getCompanyTimesheets(1, 25, '', data, sort)
     
      let filterData = {
        approvalNeeded: data && data.approvalNeeded ? data.approvalNeeded.id === 0 ? 'Approval Needed - Yes' : data.approvalNeeded.id === 1 ? 'Approval Needed - No' : '' : undefined,
        customerId: data && data.customerId && data.customerId.map((item: any) => item.companyName),
        leaves: data && data.leaves ? data.leaves.id === 0 ? 'Leaves - Allowed' : data.leaves.id === 1 ? 'Leaves - Not Allowed' : '' : undefined,
        leavesCarryForward: data && data.leavesCarryForward ? data.leavesCarryForward.id === 0 ? 'Leaves Carry Forward - Allowed' : data.leavesCarryForward.id === 1 ? 'Leaves Carry Forward - Not Allowed': '' : undefined
      }
      setFilterValues(filterData)

    }

    const searchChange = (e: any) => {
       getCompanyTimesheets(1, 25, e, '', sort)
    }

    const closeTag = (data: any) => {
      if (
        Object.values(data).every((item) => {
          if (item === undefined) {
            return true;
          }
        }) === false
      ) {
        let value = {
          filters: data,
        };
        applyFilter(value);
      } else {
        let value = {
        };
        applyFilter(value);
      }
  }

  const applySort = (sort: any) => { 
     getCompanyTimesheets(1, 25, '', '', sort)   
  }
  
  const pageChange = (pageSize: number, pageNumber: number) => {    
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;      
    getCompanyTimesheets(page, pageSize, '', '', sort) 
    }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} opentimesheet={'companyTimesheets'} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          applyCompanysheetFilter={applyFilter}
          filterNumber={filterNumber}
          searchChange={searchChange}
          closeTag={closeTag}
          filterValues={filterValues}
          type='companyTimesheet'
          companyList={companyList}
        />
        <div className={Styles.totalCounts}><img src={totalCountIcon}/>Total Counts<span>{timesheetCount}</span></div>
        <section className="contentBox">
          <div className="innerPadd24">
            <Table type='companyTimesheets' data={timesheetData} total={timesheetCount} pageSize={pageChange} setSort={setSort} applySort={applySort}/>
          </div>
        </section>
      </div>
    </section>
  )
}

export default CompanyTimesheet